import React from "react"
import { Checkbox, Col, Row } from "react-bootstrap"

export default function SimpleCheckboxRow({ value, text }) {

  return (
    <Row>
      <Col xs={3}><strong>{ text }</strong></Col>
      <Col xs={9}>
        <Checkbox checked={ value } readOnly></Checkbox>
        <hr/>
      </Col>
    </Row>
  )
}



// WEBPACK FOOTER //
// ./src/components/fragments/SimpleCheckboxRow.js